export default __webpack_public_path__ + "static/media/9.fa7e61ea.png";